import React, { useState } from 'react';
import styled from 'styled-components';

import ToggleSlider from '#/components/basic/inputs/ToggleSlider/ToggleSlider';
import Link from '#/components/basic/Link/Link';
import { useConfirmationModal } from '#/components/basic/modal/ConfirmationModal';
import { CODE_REQUIRED_OVERLAY } from '#/config/constants';

const Content = styled.div`
  max-width: 540px;
  margin: 0 auto;
  line-height: normal;
  font-size: var(--medium);
`;

const TermsContent = ({
  checkedUS,
  checkedTerms,
  onCheckUS,
  onCheckTerms,
}: {
  checkedUS: boolean;
  checkedTerms: boolean;
  onCheckUS: (check: boolean) => void;
  onCheckTerms: (check: boolean) => void;
}) => {
  const termsLink = CODE_REQUIRED_OVERLAY ? '/terms' : '/legal';
  return (
    <Content>
      By clicking "Accept" below you confirm that (i) you do not have your legal
      residence in the United States; (ii) you are not a U.S. person as defined
      under U.S. securities laws; and (iii) that you have read the{' '}
      <Link href={termsLink} target="_blank" underline>
        Terms of Service
      </Link>{' '}
      (the “Terms”) and agree with them. You further confirm that you are
      authorized to accept the Terms on behalf of yourself or the entity on
      behalf of which you are accessing this application. The Terms will remain
      in effect with respect to all content provided or transactions executed
      regardless of any termination of services between you and us.
      <div style={{ paddingTop: 8 }}>
        <ToggleSlider
          onChange={onCheckUS}
          checked={checkedUS}
          inline
          childrenAlignTop
        >
          I do not reside in, am not located in, am not incorporated in, and do
          not have a registered office or principal place of business in the
          United States.
        </ToggleSlider>
        <div style={{ padding: 4 }} />
        <ToggleSlider onChange={onCheckTerms} checked={checkedTerms}>
          I agree to the{' '}
          <Link href={termsLink} target="_blank" underline>
            Terms of Service
          </Link>
          .
        </ToggleSlider>
      </div>
    </Content>
  );
};

export default function useTermsConfirmModal(
  onAccept: () => void,
  onReject?: () => void
) {
  const [checkedUS, setCheckedUS] = useState(false);
  const [checkedTerms, setCheckedTerms] = useState(false);

  const [termsConfirmationPlaceholder, handleShowTermsConfirmation] =
    useConfirmationModal({
      title: 'Confirm Non-U.S. Status',
      children: (
        <TermsContent
          checkedUS={checkedUS}
          onCheckUS={setCheckedUS}
          onCheckTerms={setCheckedTerms}
          checkedTerms={checkedTerms}
        />
      ),
      onConfirm: onAccept,
      onReject,
      confirmText: 'Accept',
      confirmButtonProps: {
        disabled: !checkedUS || !checkedTerms,
        autoFocus: true,
      },
    });
  return {
    termsConfirmationPlaceholder,
    handleShowTermsConfirmation,
  };
}
